var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    stroke: "current",
    strokeWidth: 0.6,
    fill: "current",
    strokeLinecap: "round",
    style: {
      cursor: "pointer"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "0.2s",
    attributeName: "d",
    values: "M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7;M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7",
    fill: "freeze",
    begin: "start.begin"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "0.2s",
    attributeName: "d",
    values: "M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7;M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7",
    fill: "freeze",
    begin: "reverse.begin"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "2s",
    id: "reverse",
    attributeName: "width",
    begin: "click"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "0.001s",
    id: "start",
    attributeName: "width",
    values: "10;0",
    fill: "freeze",
    begin: "click"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "0.001s",
    attributeName: "width",
    values: "0;10",
    fill: "freeze",
    begin: "reverse.begin"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.861f8bf9cddeda2a594d9fec5e334ce9.svg";
export { ForwardRef as ReactComponent };